/**
 * Action types for the collaborative images system
 *
 * - JOIN_ROOM_*: Handles room connection
 * - SHARE_IMAGE_*: Full flow for sharing images
 * - RECEIVE_IMAGE_*: Flow for receiving shared images
 */
// Flow for joining the meeting
export const JOIN_ROOM_REQUEST = 'collab-images/JOIN_ROOM_REQUEST';
export const JOIN_ROOM_SUCCESS = 'collab-images/JOIN_ROOM_SUCCESS';
export const JOIN_ROOM_FAILURE = 'collab-images/JOIN_ROOM_FAILURE';
export const LEFT_ROOM = 'collab-images/LEFT_ROOM';
// Flow for sharing images
/**
 * The user intends to share an image.
 * This action is dispatched before any validation or upload begins.
 */
export const SHARE_IMAGE_INTENT = 'collab-images/SHARE_IMAGE_INTENT';
/**
 * The system blocks the image sharing attempt.
 * This may occur due to permissions, room state, or upload limits.
 */
export const SHARE_IMAGE_BLOCKED = 'collab-images/SHARE_IMAGE_BLOCKED';
/**
 * The image upload process has started.
 * This indicates that the image is being sent to the server.
 */
export const SHARE_IMAGE_UPLOAD_START = 'collab-images/SHARE_IMAGE_UPLOAD_START';
/**
 * The image has been successfully uploaded to the server.
 * This confirms that the image is ready to be shared with other participants.
 */
export const SHARE_IMAGE_UPLOAD_SUCCESS = 'collab-images/SHARE_IMAGE_UPLOAD_SUCCESS';
/**
 * The image upload has failed.
 * This could be due to network issues, server errors, or invalid file formats.
 */
export const SHARE_IMAGE_UPLOAD_FAILURE = 'collab-images/SHARE_IMAGE_UPLOAD_FAILURE';
// Flow for receiving images
export const ID_IMAGE_RECEIVED = 'collab-images/ID_IMAGE_RECEIVED';
export const ID_IMAGE_RECEIVED_LOCKED = 'collab-images/ID_IMAGE_RECEIVED_LOCKED';
export const IMAGE_RECEIVED_DOWNLOAD_START = 'collab-images/IMAGE_RECEIVED_DOWNLOAD_START';
export const IMAGE_RECEIVED_DOWNLOAD_SUCCESS = 'collab-images/IMAGE_RECEIVED_DOWNLOAD_SUCCESS';
export const IMAGE_RECEIVED_DOWNLOAD_FAILURE = 'collab-images/IMAGE_RECEIVED_DOWNLOAD_FAILURE';
//
export const SET_EXCALIDRAW_API = 'collab-images/SET_EXCALIDRAW_API';
export const REMOVE_IMAGE = 'collab-images/REMOVE_IMAGE';
